import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Check, X } from 'lucide-react';
import toast from 'react-hot-toast';

interface SimRequest {
  id: number;
  user_id: number;
  scenario_id: number;
  status: string;
  scenario_name: string;
  created_at: string;
  first_name: string;
  last_name: string;
  email: string;
}

export default function SimulationRequests() {
  const [requests, setRequests] = useState<SimRequest[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchRequests = async () => {
    try {
      const res = await api.get('/simulations/requests');
      setRequests(res.data);
    } catch {
      toast.error('Erreur de chargement');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const approve = async (id: number) => {
    try {
      await api.post(`/simulations/requests/${id}/approve`);
      toast.success('Demande approuvée');
      fetchRequests();
    } catch {
      toast.error('Erreur');
    }
  };

  const deny = async (id: number) => {
    try {
      await api.post(`/simulations/requests/${id}/deny`);
      toast.success('Demande refusée');
      fetchRequests();
    } catch {
      toast.error('Erreur');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-2xl font-bold mb-4">Demandes de simulation</h1>
        {requests.length === 0 ? (
          <p className="text-gray-500">Aucune demande en attente.</p>
        ) : (
          <ul className="space-y-4">
            {requests.map((r) => (
              <li key={r.id} className="border rounded-lg p-4 flex items-center justify-between">
                <div>
                  <p className="font-medium">Nom : {r.last_name}</p>
                  <p className="font-medium">Prénom : {r.first_name}</p>
                  <p className="font-medium">Email : {r.email}</p>
                  <p className="text-sm text-gray-600">Scénario #{r.scenario_id} - {r.scenario_name}</p>
                  <p className="text-sm text-gray-500 mt-1">{new Date(r.created_at).toLocaleString()}</p>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => approve(r.id)} className="p-2 bg-green-500 text-white rounded hover:bg-green-600">
                    <Check className="w-4 h-4" />
                  </button>
                  <button onClick={() => deny(r.id)} className="p-2 bg-red-500 text-white rounded hover:bg-red-600">
                    <X className="w-4 h-4" />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}